// removed by extract-text-webpack-plugin
module.exports = {"icon":"fontIcon--icon--1zVVHFL7","regular":"fontIcon--regular--3uEex5Fb","is-small":"fontIcon--is-small--1w3JH6Bh","isSmall":"fontIcon--is-small--1w3JH6Bh","is-disabled":"fontIcon--is-disabled--1csyM_V-","isDisabled":"fontIcon--is-disabled--1csyM_V-","is-danger":"fontIcon--is-danger--3sSvyGiL","isDanger":"fontIcon--is-danger--3sSvyGiL","is-inherit":"fontIcon--is-inherit--1trAa3vp","isInherit":"fontIcon--is-inherit--1trAa3vp","is-white":"fontIcon--is-white--1hvPGEqn","isWhite":"fontIcon--is-white--1hvPGEqn","is-green":"fontIcon--is-green--3NOk3bgD","isGreen":"fontIcon--is-green--3NOk3bgD"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/FontIcon/fontIcon.scss
// module id = 466
// module chunks = 0